export const scrollbarStyle = (
  theme: any,
  {
    width = '0.4rem',
    borderRadius = '1.5rem',
  }: { width?: string; borderRadius?: string } = {},
) => ({
  '&::-webkit-scrollbar': {
    display: 'block',
    width,
  },
  '&::-webkit-scrollbar-track': {
    boxShadow: 'inset 0 0 6px rgba(0,0,0,0.00)',
    backgroundColor: theme.palette.LUX.obTokens.bgColorFunctionalInfo,
  },
  '&::-webkit-scrollbar-thumb': {
    backgroundColor: theme.palette.LUX.obTokens.actionColorBgBrand,
    outline: `1px solid ${theme.palette.LUX.obTokens.actionColorBgBrand}`,
    borderRadius,
  },
});
